<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { box-sizing: border-box; }
html, body, #app, #app-root {
  width: 100%;
  height: 100%;
  margin: 0;
}
body {
  overflow: hidden;
  font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,sans-serif;
  color: #333;
  background: #fff;
}
#app-root { position: relative; background: #fff; }
/* 侧栏折叠箭头：镜像若缺 icon_arrow.png 用 CSS 兜底 */
.anCore-dislpayArrow a {
  background-image: none !important;
  width: 12px;
  height: 48px;
  margin-top: -24px;
  border: 1px solid #ddd;
  border-left: none;
  background: #f5f5f5 !important;
  border-radius: 0 3px 3px 0;
}
.anCore-dislpayArrow a::after {
  content: '';
  display: block;
  width: 0; height: 0;
  margin: 18px 0 0 2px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 6px solid #999;
}
.anCore-dislpayArrow a.anCore-open::after {
  margin-left: 3px;
  border-right: none;
  border-left: 6px solid #999;
}
</style>
